(() => {
  const isArabic =
    document.documentElement.dir === 'rtl' ||
    (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const addedText = isArabic ? 'تمت الإضافة ✓' : 'Added ✓';

  function pulseCart() {
    document.querySelectorAll('.header__icon--cart, .header__cart').forEach((icon) => {
      icon.classList.remove('sf-cart-icon-pulse');
      void icon.offsetWidth;
      icon.classList.add('sf-cart-icon-pulse');
    });
  }

  function feedback(button) {
    if (!button) return;
    const label = button.querySelector('span, .product-form__submit-text');
    const oldText = label?.textContent || '';
    button.classList.add('is-added', 'sf-cart-success');
    if (label) label.textContent = addedText;
    window.setTimeout(() => {
      button.classList.remove('is-added', 'sf-cart-success');
      if (label && oldText) label.textContent = oldText;
    }, 1500);
    pulseCart();
  }

  function errorFeedback(button) {
    if (!button) return;
    const label = button.querySelector('span, .product-form__submit-text');
    const oldText = label?.textContent || '';
    button.classList.add('is-error');
    if (label) label.textContent = isArabic ? 'تعذّرت الإضافة' : 'Could not add';
    window.setTimeout(() => {
      button.classList.remove('is-error');
      if (label && oldText) label.textContent = oldText;
    }, 1800);
  }

  function updateCount(cart) {
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      const number =
        bubble.querySelector('[aria-hidden="true"]') || bubble.querySelector('span') || bubble;
      number.textContent = cart.item_count;
      bubble.classList.toggle('hidden', !cart.item_count);
    });
  }

  async function refreshCartData() {
    try {
      const cartRoute = (window.routes?.cart_url || '/cart').replace(/\/$/, '');
      const cart = await fetch(`${cartRoute}.js`, { headers: { Accept: 'application/json' } }).then(
        (response) => response.json(),
      );
      updateCount(cart);
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            cart,
            totalPrice: cart.total_price,
            items: cart.items,
            timestamp: Date.now(),
          },
          bubbles: true,
        }),
      );
      return cart;
    } catch (_error) {
      return null;
    }
  }

  async function addGridProduct(form, button, requestedVariantId = '') {
    const predictiveSearch = button?.closest('predictive-search');
    const item = form?.closest('[data-sf-spare-parts-product]');
    const variantId = String(requestedVariantId || item?.dataset.sfVariantId || '').replace(/\D+/g, '');
    if (form && variantId) {
      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (variantInput) variantInput.value = variantId;
      if (quantityInput) quantityInput.value = '1';
    }
    const formData = form ? new FormData(form) : new FormData();
    if (variantId) {
      formData.set('id', variantId);
      formData.set('quantity', '1');
    }
    if (!formData.get('id')) throw new Error('variant');
    const cartSurface =
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    if (cartSurface && typeof cartSurface.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartSurface
          .getSectionsToRender()
          .map((section) => section.id)
          .join(','),
      );
      formData.append('sections_url', window.location.pathname);
    }

    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'cart');

    if (predictiveSearch) {
      if (typeof predictiveSearch.forceClose === 'function') predictiveSearch.forceClose();
      else predictiveSearch.close?.(false, false);
    }

    let drawerRendered = false;
    if (cartSurface && data.sections && typeof cartSurface.renderContents === 'function') {
      try {
        cartSurface.renderContents(data);
        cartSurface.classList.remove('is-empty');
        drawerRendered = true;
      } catch (error) {
        console.error('[SF Cart] drawer render error', error);
      }
    }

    feedback(button);
    await refreshCartData();

    if (!cartSurface) {
      window.location.assign(window.routes?.cart_url || '/cart');
      return;
    }

    if (!drawerRendered) cartSurface.open?.(button);
  }

  function initCartFallback() {
    const icon = document.querySelector('#cart-icon-bubble');
    const drawer = document.querySelector('cart-drawer');
    if (!icon || !drawer) return;

    icon.addEventListener(
      'click',
      (event) => {
        if (drawer.initialized) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        pulseCart();
        if (typeof drawer.open === 'function') {
          drawer.open(icon);
          return;
        }
        drawer.classList.add('active');
        document.body.classList.add('overflow-hidden', 'has-cart-opened');
      },
      true,
    );
  }

  function ensureCardBuyRow(card) {
    const information = card.querySelector('.product-card__information');
    const sourceAction = card.querySelector(
      '.product-card__media > .sf-grid-cart-form, .product-card__media > .sf-grid-cart',
    );
    if (!information || !sourceAction) return;

    const partsAction = information.querySelector(
      '.sf-parts-card__buy-row .sf-parts-card__cart-form, .sf-parts-card__buy-row .sf-parts-card__cart',
    );
    if (partsAction) {
      sourceAction.remove();
      return;
    }

    let row = information.querySelector(':scope > .sf-card-buy-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'sf-card-buy-row';

      const price = [...information.children].find(
        (child) =>
          child.matches?.('.price, .sf-parts-card__price') || child.querySelector?.(':scope > .price'),
      );
      if (price) price.insertAdjacentElement('afterend', row);
      else information.append(row);
    }

    row.append(sourceAction);
    sourceAction.classList.add('sf-card-buy-row__action');
  }

  function removeProductButtonPrices(root = document) {
    root
      .querySelectorAll(
        '.template-product .product-form__submit-text, .template-product sticky-cart-button .product-form__submit-text',
      )
      .forEach((label) => {
        const cleanLabel = (label.textContent || '')
          .replace(/(?:OMR|ر\.?\s*ع\.?|ر\.ع)\s*[\d.,]+|[\d.,]+\s*(?:OMR|ر\.?\s*ع\.?|ر\.ع)/giu, '')
          .replace(/[\s\u00a0]+/g, ' ')
          .replace(/[-–—|]+\s*$/u, '')
          .trim();
        if (cleanLabel && cleanLabel !== label.textContent.trim()) label.textContent = cleanLabel;
      });
  }

  const MAX_VISIBLE_FITMENTS = 3;
  let fitmentListId = 0;

  function isVehicleFitmentTag(tag) {
    if (!tag || /^(?:القسم|النوع|brand|vendor)\s*:/iu.test(tag)) return false;
    return /-(?:esi|esr)\d+$/iu.test(tag) || /(?:19|20)\d{2}/u.test(tag);
  }

  function formatVehicleFitment(tag) {
    const label = tag
      .replace(/-(?:esi|esr)\d+$/iu, '')
      .replace(/((?:19|20)\d{2})-((?:19|20)\d{2})/gu, '$1–$2')
      .replace(/(\d+)-(\d+)l\b/giu, '$1.$2L')
      .replace(/(\d+)cyl\b/giu, '$1 Cyl')
      .replace(/[-_]+/gu, ' ')
      .replace(/\s+/gu, ' ')
      .trim();

    return label.replace(/\b[a-z][a-z0-9]*\b/giu, (word) => {
      if (/^(?:l|v\d+|i\d+|cyl)$/iu.test(word)) return word.toUpperCase();
      return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
    });
  }

  function setFitmentExpanded(list, expanded) {
    const items = [...list.querySelectorAll('.sf-parts-card__fitment-item')];
    items.forEach((item, index) => {
      item.hidden = !expanded && index >= MAX_VISIBLE_FITMENTS;
    });
    list.classList.toggle('is-expanded', expanded);

    const button = list.querySelector('[data-sf-fitment-more]');
    if (!button) return;
    const hiddenCount = Math.max(0, items.length - MAX_VISIBLE_FITMENTS);
    button.setAttribute('aria-expanded', String(expanded));
    button.setAttribute(
      'aria-label',
      expanded
        ? isArabic
          ? 'إخفاء السيارات الإضافية'
          : 'Hide additional compatible vehicles'
        : isArabic
          ? 'عرض بقية السيارات المتوافقة'
          : 'Show more compatible vehicles',
    );
    button.textContent = expanded
      ? isArabic
        ? 'عرض أقل'
        : 'Show less'
      : isArabic
        ? `+${hiddenCount} المزيد`
        : `+${hiddenCount} more`;
  }

  function renderCardFitment(card) {
    if (document.body.dataset.sfCardFitmentEnabled !== 'true') return;
    const rawTags = card.dataset.fitmentTags || '';
    if (!rawTags.trim()) return;

    let list = card.querySelector('[data-sf-selected-fitment]');
    const sku = card.querySelector('.sf-parts-card__sku, [data-sf-part-number], .product-card__sku');
    if (!list) {
      const block = document.createElement('div');
      block.className = 'sf-parts-card__fitment';
      block.innerHTML = `<span class="sf-parts-card__fitment-label">${isArabic ? 'متوافق مع' : 'Compatible with'}</span><span class="sf-parts-card__fitment-list" data-sf-selected-fitment></span>`;
      const meta = card.querySelector('.sf-parts-card__meta, .product-card__information');
      if (sku) sku.insertAdjacentElement('afterend', block);
      else if (meta) meta.append(block);
      else return;
      list = block.querySelector('[data-sf-selected-fitment]');
    } else if (sku) {
      const existingBlock = list.closest('.sf-parts-card__fitment');
      if (existingBlock && sku.nextElementSibling !== existingBlock) {
        sku.insertAdjacentElement('afterend', existingBlock);
      }
    }
    if (list.hasAttribute('data-sf-fitment-ready')) return;

    const vehicles = [...new Set(
      rawTags
        .split('||')
        .map((tag) => tag.trim())
        .filter(isVehicleFitmentTag)
        .map(formatVehicleFitment)
        .filter(Boolean),
    )];

    list.replaceChildren();
    list.setAttribute('data-sf-fitment-ready', '');

    const fitmentBlock = list.closest('.sf-parts-card__fitment');
    if (!vehicles.length) {
      if (fitmentBlock) fitmentBlock.hidden = true;
      return;
    }

    if (fitmentBlock) fitmentBlock.hidden = false;
    list.id ||= `sf-card-fitment-${++fitmentListId}`;

    vehicles.forEach((vehicle) => {
      const item = document.createElement('span');
      item.className = 'sf-parts-card__fitment-item';
      item.dir = 'auto';
      item.textContent = vehicle;
      list.append(item);
    });

    if (vehicles.length > MAX_VISIBLE_FITMENTS) {
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'sf-parts-card__fitment-more';
      more.setAttribute('data-sf-fitment-more', '');
      more.setAttribute('aria-controls', list.id);
      list.append(more);
      setFitmentExpanded(list, false);
    }
  }

  let surfaceScanTimer = 0;
  function scanCommerceSurfaces() {
    document
      .querySelectorAll(
        '.template-collection #product-grid .product-card, .template-search #product-grid .product-card',
      )
      .forEach((card) => {
        ensureCardBuyRow(card);
        renderCardFitment(card);
      });
    removeProductButtonPrices();
  }

  function initCommerceSurfaces() {
    scanCommerceSurfaces();
    const root = document.querySelector('#MainContent') || document.body;
    new MutationObserver(() => {
      window.clearTimeout(surfaceScanTimer);
      surfaceScanTimer = window.setTimeout(scanCommerceSurfaces, 80);
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-fitment-tags'] });
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-sf-fitment-more]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const list = button.closest('[data-sf-selected-fitment]');
      if (list) setFitmentExpanded(list, button.getAttribute('aria-expanded') !== 'true');
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      const cartButton = event.target.closest('[data-sf-predictive-cart]');
      if (cartButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (cartButton.disabled) return;
        cartButton.disabled = true;
        cartButton.classList.add('is-loading');
        addGridProduct(null, cartButton, cartButton.dataset.variantId)
          .catch((error) => {
            console.error('[SF Cart] predictive add error', error);
            errorFeedback(cartButton);
          })
          .finally(() => {
            cartButton.disabled = false;
            cartButton.classList.remove('is-loading');
          });
        return;
      }

      const optionsButton = event.target.closest('[data-sf-predictive-options]');
      if (!optionsButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const productUrl = optionsButton.dataset.productUrl;
      if (productUrl) window.location.assign(productUrl);
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      const productLink = event.target.closest(
        '.product-card__heading a, .product-card__media a',
      );
      if (
        productLink &&
        !event.target.closest('button, form, .sf-parts-card__thumbs')
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(productLink.href);
      }
    },
    true,
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartFallback, { once: true });
    document.addEventListener('DOMContentLoaded', initCommerceSurfaces, { once: true });
  } else {
    initCartFallback();
    initCommerceSurfaces();
  }

  document.addEventListener(
    'submit',
    (event) => {
      const gridForm = event.target.closest('[data-sf-grid-cart]');
      if (gridForm && !gridForm.closest('[data-sf-oil-finder]')) {
        event.preventDefault();
        const button = gridForm.querySelector('.sf-grid-cart, .sf-parts-card__cart');
        if (!button || button.disabled) return;
        button.disabled = true;
        button.classList.add('is-loading');
        addGridProduct(gridForm, button)
          .catch((error) => {
            console.error('[SF Cart] add error', error);
            errorFeedback(button);
          })
          .finally(() => {
            button.disabled = false;
            button.classList.remove('is-loading');
          });
        return;
      }

      const productForm = event.target.closest(
        'product-form form, [data-type="add-to-cart-form"]',
      );
      if (!productForm) return;
      const button = productForm.querySelector('[type="submit"]');
      if (!button) return;
      document.querySelectorAll('[data-sf-last-product-submit]').forEach((markedButton) => {
        markedButton.removeAttribute('data-sf-last-product-submit');
      });
      button.setAttribute('data-sf-last-product-submit', '');
    },
    true,
  );

  document.addEventListener('cart:updated', () => {
    const button = document.querySelector('[data-sf-last-product-submit]');
    if (button) {
      button.removeAttribute('data-sf-last-product-submit');
      feedback(button);
    } else {
      pulseCart();
    }
  });
})();
